// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { MemoryRouter, Route, Routes } from "react-router-dom";
import Home from "screens/Home/Home";

const Router: React.FC = () => {
  return (
    <MemoryRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </MemoryRouter>
  );
};

export default Router;
